import React from 'react';
import { Icon, iconPropTypes } from './Icon';

const SuspendIcon = function SuspendIcon({ size, color }) {
    return (
        <Icon size={size} color={color}>
            <i className="fa fa-ban" />
        </Icon>
    );
};

export default SuspendIcon;

SuspendIcon.propTypes = iconPropTypes;
SuspendIcon.defaultProps = Icon.defaultProps;
